import { Root } from './root';

describe('app', () => {
  it('builds', () => {
    expect(new Root()).toBeTruthy();
  });
});
